export default "__VITE_ASSET__75b325cb__"